import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCreateHistoryEntryType } from "../../../hooks/history/useCreateHistoryEntryType";

const DefaultHistoryEntryTypesSeederDialog = ({ open = false, setOpen, successCallback }) => {

    const { t } = useTranslation('common');

    const defaultTypes = [
        {name: "Consultation"},
        {name: "Vaccination"},
        {name: "Treatment"},
        {name: "Blood Chemistry"},
        {name: "X-ray"},
        {name: "Fecalysis"},
        {name: "Urinalysis"},
        {name: "Skin Scraping"},
        {name: "Ear Mite Detection"},
        {name: "Boarding"},
        {name: "Grooming"},
        {name: "Confinement"},
        {name: "Rare Case"},
        {name: "Others"}
    ];
    
    const handleClose = (event, reason) => {
        // Prevent closing when clicking the backdrop or pressing Escape
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
        return;
        }
        setOpen(false);
    };

    const { create } = useCreateHistoryEntryType(successCallback);

    const onConfirm = () => {
        createDefaultTypes();
        setOpen(false);
    }

    const createDefaultTypes = async () => {
        await create(defaultTypes);
    };

    return (
        <Dialog open={open} onClose={handleClose} disableRestoreFocus>
                <DialogTitle>
                    Medical History Initial Setup...
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body1">
                        Medical History module ready to use.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                    onClick={onConfirm}
                    color="primary"
                    >
                    Close
                    </Button>
                </DialogActions>
        </Dialog>
  );
};

export default DefaultHistoryEntryTypesSeederDialog;